const DEFAULT_ZOOM_ON_CITY = 10;
const DEFAULT_ZOOM = 5;
const DEBOUNCE_TIME = 1000;

const Z_INDEX_ULTIMATE = 3;
const Z_INDEX_HOVER = 2;
const Z_INDEX_DEFAULT = 1;

const MAP_ID = 'd014e286f2890fa667ac6589';

export { DEFAULT_ZOOM_ON_CITY, DEFAULT_ZOOM, DEBOUNCE_TIME, Z_INDEX_ULTIMATE, Z_INDEX_HOVER, Z_INDEX_DEFAULT, MAP_ID };